export default __webpack_public_path__ + "static/media/banner-5.de94ccc5.jpg";